export const SYSTEM_PROPS = {
  m: {
    type: 'spacing',
    property: 'margin'
  },
  mt: {
    type: 'spacing',
    property: 'marginTop'
  },
  mb: {
    type: 'spacing',
    property: 'marginBottom'
  },
  ml: {
    type: 'spacing',
    property: 'marginLeft'
  },
  mr: {
    type: 'spacing',
    property: 'marginRight'
  },
  mx: {
    type: 'spacing',
    property: ['marginRight', 'marginLeft']
  },
  my: {
    type: 'spacing',
    property: ['marginTop', 'marginBottom']
  },
  p: {
    type: 'spacing',
    property: 'padding'
  },
  pt: {
    type: 'spacing',
    property: 'paddingTop'
  },
  pb: {
    type: 'spacing',
    property: 'paddingBottom'
  },
  pl: {
    type: 'spacing',
    property: 'paddingLeft'
  },
  pr: {
    type: 'spacing',
    property: 'paddingRight'
  },
  px: {
    type: 'spacing',
    property: ['paddingRight', 'paddingLeft']
  },
  py: {
    type: 'spacing',
    property: ['paddingTop', 'paddingBottom']
  },
  w: {
    type: 'size',
    property: 'width'
  },
  miw: {
    type: 'size',
    property: 'minWidth'
  },
  maw: {
    type: 'size',
    property: 'maxWidth'
  },
  h: {
    type: 'size',
    property: 'height'
  },
  mih: {
    type: 'size',
    property: 'minHeight'
  },
  mah: {
    type: 'size',
    property: 'maxHeight'
  },
  bg: {
    type: 'color',
    property: 'background'
  },
  c: {
    type: 'color',
    property: 'color'
  },
  fill: {
    type: 'color',
    property: 'fill'
  },
  opacity: {
    type: 'identity',
    property: 'opacity'
  },
  pos: {
    type: 'identity',
    property: 'position'
  },
  top: {
    type: 'spacing',
    property: 'top'
  },
  left: {
    type: 'spacing',
    property: 'left'
  },
  bottom: {
    type: 'spacing',
    property: 'bottom'
  },
  right: {
    type: 'spacing',
    property: 'right'
  },
  display: {
    type: 'identity',
    property: 'display'
  },
  flex: {
    type: 'identity',
    property: 'flex'
  },
  flexGrow: {
    type: 'identity',
    property: 'flexGrow'
  },
  flexShrink: {
    type: 'identity',
    property: 'flexShrink'
  },
  flexBasis: {
    type: 'identity',
    property: 'flexBasis'
  },
  alignContent: {
    type: 'identity',
    property: 'alignContent'
  },
  alignItems: {
    type: 'identity',
    property: 'alignItems'
  },
  alignSelf: {
    type: 'identity',
    property: 'alignSelf'
  },
  flexDirection: {
    type: 'identity',
    property: 'flexDirection'
  },
  justifyContent: {
    type: 'identity',
    property: 'justifyContent'
  },
  flexWrap: {
    type: 'identity',
    property: 'flexWrap'
  },
  order: {
    type: 'identity',
    property: 'order'
  },
  gap: {
    type: 'spacing',
    property: 'gap'
  },
  overflow: {
    type: 'identity',
    property: 'overflow'
  },
  overflowX: {
    type: 'identity',
    property: 'overflowX'
  },
  overflowY: {
    type: 'identity',
    property: 'overflowY'
  },
  zIndex: {
    type: 'identity',
    property: 'zIndex'
  },
  ta: {
    type: 'identity',
    property: 'textAlign'
  },
  va: {
    type: 'identity',
    property: 'verticalAlign'
  },
  fontSize: {
    type: 'size',
    property: 'fontSize'
  },
  fw: {
    type: 'identity',
    property: 'fontWeight'
  },
  b: {
    type: 'identity',
    property: 'border'
  },
  bs: {
    type: 'identity',
    property: 'borderStyle'
  },
  bc: {
    type: 'color',
    property: 'borderColor'
  },
  bw: {
    type: 'size',
    property: 'borderWidth'
  },
  btw: {
    type: 'size',
    property: 'borderTopWidth'
  },
  bbw: {
    type: 'size',
    property: 'borderBottomWidth'
  },
  blw: {
    type: 'size',
    property: 'borderLeftWidth'
  },
  brw: {
    type: 'size',
    property: 'borderRightWidth'
  },
  br: {
    type: 'size',
    property: 'borderRadius'
  },
  btr: {
    type: 'size',
    property: ['borderTopLeftRadius', 'borderTopRightRadius']
  },
  bbr: {
    type: 'size',
    property: ['borderBottomLeftRadius', 'borderBottomRightRadius']
  },
  btlr: {
    type: 'size',
    property: 'borderTopLeftRadius'
  },
  btrr: {
    type: 'size',
    property: 'borderTopRightRadius'
  },
  bblr: {
    type: 'size',
    property: 'borderBottomLeftRadius'
  },
  bbrr: {
    type: 'size',
    property: 'borderBottomRightRadius'
  },
  transition: {
    type: 'identity',
    property: 'transition'
  },
  transform: {
    type: 'identity',
    property: 'transform'
  },
  backgroundImage: {
    type: 'identity',
    property: 'backgroundImage'
  },
  backgroundSize: {
    type: 'identity',
    property: 'backgroundSize'
  },
  backgroundRepeat: {
    type: 'identity',
    property: 'backgroundRepeat'
  },
  backgroundPosition: {
    type: 'identity',
    property: 'backgroundPosition'
  },
  objectFit: {
    type: 'identity',
    property: 'objectFit'
  },
  aspectRatio: {
    type: 'identity',
    property: 'aspectRatio'
  },
  outline: {
    type: 'identity',
    property: 'outline'
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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